import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../component/pages/Home";
import Detail from "../component/pages/Detail";

const Router = () => {
     return (
          <BrowserRouter>
               <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="Detail" element={<Detail />} />
                    <Route path="Detail/:id" element={<Detail />} />
                    {/* detail에서 id값에 따라 다른 페이지가 될 수 있도록 Detail/:id로 들어감 */}
               </Routes>
          </BrowserRouter>
     );
};

export default Router;
